import { GeoEditSession } from './GeoEditSession';
import { CompositeGeoEditAdapter } from './CompositeGeoEditAdapter';
import { type GeoEditOperation } from '@visualizer/types';
import { Geodata } from '@data/Geodata';
import { BuildingsGeoEditAdapter } from './BuildingsGeoEditAdapter';
import { TreesGeoEditAdapter } from './TreesGeoEditAdapter';

export class GeoEditManager {
    private session: GeoEditSession;

    // Add Operation
    private nextTempId = -1;

    constructor(
        adapter: CompositeGeoEditAdapter,
        private readonly afterSave?: () => void | Promise<void>
    ) {
        this.session = new GeoEditSession(adapter);
    }

    static createFromGeodata(geo: Geodata, afterSave?: () => void | Promise<void>): GeoEditManager | null {
        const buildings = geo.dataObject.Buildings;
        const trees = geo.dataObject.Trees;

        if (!buildings && !trees) return null;

        const adapter = new CompositeGeoEditAdapter(
            buildings && new BuildingsGeoEditAdapter(buildings),
            trees && new TreesGeoEditAdapter(trees)
        );

        return new GeoEditManager(adapter, afterSave);
    }

    allocateTempId(): number {
        return this.nextTempId--;
    }

    apply(op: GeoEditOperation) {
        this.session.applyOperation(op);
    }

    undo() {
        this.session.undo();
    }

    redo() {
        this.session.redo();
    }

    clear() {
        this.session.clear();
    }

    getOperations() {
        return this.session.getOperations();
    }

    async save(newGeodataId?: string, newGeodataName?: string) {
        try {
            if (!newGeodataId) newGeodataId = crypto.randomUUID();
            await this.session.saveToServer(newGeodataId, newGeodataName);
        } catch (e: any) {
            throw e;
        } finally {
            await this.afterSave?.();
        }
    }
}
